export const rootData = (state) => state.rootData

export const selected = (state) => state.selected

export const isLoading = (state) => state.loading



// WEBPACK FOOTER //
// ./src/store/modules/tree/getters.js